import { HostFamilyBase } from "../HostFamilyBase";

export class InterestedFamiliesController extends HostFamilyBase {

    isOnlineOrAwaiting: boolean;
    isToBeMatch: boolean;
    isRematch: boolean;
    isActiveApp: boolean;
    isPlacedOrActive: boolean;
    isPlaced: boolean;
    interestedFamiliesRequestStatus: string;
    pndMatch: boolean;

    interestedFamiliesGroups;

    static override $inject = ['$scope', '$sce', '$uibModal', '$state', 'dialogs', 'applicationId', 'PlacementMatchesDetails', 'InterestedHostFamiliesDetails', 'applicationObservable', '$stateParams', 'Auth']
    constructor($scope: angular.IScope, $sce, $uibModal, $state, private dialogs, applicationId, public PlacementMatchesDetails, InterestedHostFamiliesDetails, applicationObservable, private $stateParams, private Auth) {
        super($uibModal, InterestedHostFamiliesDetails, $state, applicationId)


        applicationObservable.subscribe(applicationInstance => {
            this.isToBeMatch = (applicationInstance.status === 'TBM');
            this.isRematch = (applicationInstance.status === 'REM');
            this.isActiveApp = (applicationInstance.status === 'ACT');
            this.isPlaced = (applicationInstance.status === 'PLC');
            this.isOnlineOrAwaiting = (applicationInstance.status === 'OLA' || applicationInstance.status === 'AWA');
            this.isPlacedOrActive = (applicationInstance.status === 'PLC' || applicationInstance.status === 'ACT');

            if (this.isOnlineOrAwaiting || this.isToBeMatch) {
                PlacementMatchesDetails.getMatches({ applicationId: applicationId, status: 'PND' }).$promise.then((matches) => {
                    this.pndMatch = matches && matches.length > 0;
                });
            }

            if (this.isPlacedOrActive || this.isToBeMatch || this.isRematch) {
                this.loadIntrestedFamilies();
            }  
        })  
    }

    loadIntrestedFamilies() {
        this.interestedFamiliesRequestStatus = 'loading';
        this.interestedFamiliesGroups = undefined;

        this.InterestedHostFamiliesDetails.query({
            applicationId: this.applicationId
        })
            .$promise
            .then((result) => {
                this.interestedFamiliesRequestStatus = 'completed';

                let column1 = [];
                let column2 = [];

                for (let i = 0; i < result.length; i++) {
                    if (i % 2 === 0) {
                        column1.push(result[i]);
                    } else {
                        column2.push(result[i]);
                    }
                }

                this.interestedFamiliesGroups = [column1, column2];
            }, () => {
                this.interestedFamiliesRequestStatus = 'failed';
            });
    }

    selectedProposal(hfData){

        this.$stateParams.proposalId = hfData.proposalId;
        this.$stateParams.photosUrl = hfData.photosURL;
        this.$stateParams.essayUrl = hfData.essayURL;
        this.$stateParams.email = hfData.email;

        var param = {
            proposalId: hfData.proposalId,
            photosUrl: hfData.photosURL,
            essayUrl: hfData.essayURL,
            email: hfData.email,
            requestId: hfData.requestId,
            hostFamilyId: hfData.hostFamilyId
        }
        if (this.Auth.user.isApplicant) {
            this.$state.go('app.hostFamilies.hostFamilyDocuments', param);
        } else {
            this.$state.go('app.applications.hostFamilies.hostFamilyDocuments', param);
        }

    }

    interested(hf) {
        this.openFeedbackDialog(hf, true);
    }

    notInterested(hf) {
        this.openFeedbackDialog(hf, false);
    }

    override openFeedbackDialog(hf, intrested: boolean) {

        if (hf.proposalId != null || hf.essayURL != null || hf.email != null || hf.photosURL != null) {

            super.openFeedbackDialog(hf, intrested)
                .result
                .then(() => {
                    this.loadIntrestedFamilies();
                });
        }
        else {
            this.dialogs.error('Error', 'Please choose a family.')
        }
    }
}

angular
    .module('app')
    .controller('InterestedFamiliesController', InterestedFamiliesController)
